import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=62e970a0&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=62e970a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e970a0",
  null
  
)

export default component.exports